module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ok":"ok","cancel":"cancel"},"zh-tw":{"ok":"確認","cancel":"取消"}}')
  delete Component.options._Ctor
}
